module.exports = __webpack_public_path__ + "static/media/influencer-2.d770c9a9.png";